import React from 'react';

import { isFunction } from 'extra/functions';
import "./button.scss";

export default function Button (props) {
	
	const { href, target,extra_classes, children, onClick } = props;

	return (
		<a 
			href={ href || "#"}
			target={ target }
			className={`button ${ extra_classes || "" }`} 
			onClick={ e => { 
				!href && e.preventDefault();
				isFunction( onClick ) && onClick() 
			}}
		>
			{ children }
		</a>
	)
}

